const riot = require('riot');

riot.tag2('module-request-api', '<div class="section-padding rounded-8 bg-white elevation-default-low"> <div class="mb28" data-is="module-section-header" title="API用リクエスト情報"></div> <div class="ts-pxs text-gray_60 mb8">{description}</div> <textarea class="textarea w-full mb8" riot-value="{requestTemplate}" readonly rows="{textareaRows}"></textarea> <button class="button outline" type="button" onclick="{onCopyRequestTemplate}">コピー</button> </div>', 'module-request-api,[data-is="module-request-api"]{display:block}', '', function(opts) {
    var target_type = this.opts.distributionRule.raffle_rule ? 'raffle' : 'all';

    if (target_type === 'all') {
      this.description = 'この配布ルールをDistribution Event Import APIで利用するために必要なリクエスト情報です。';
      this.requestTemplate = JSON.stringify({
        distribution_rule_id: this.opts.distributionRule.id,
        distribution_target_strategy_id: this.opts.distributionTargetStrategy.id,
        service_uid: "ユーザーのidを挿入してください",
        conversion_at: "CVした日時をISO8601フォーマットの文字列型で挿入してください",
        distribution_point_amount: "発行する金額を数値型で挿入してください",
        point_provider: this.opts.distributionPointStrategy.point_provider,
        email: "発行対象のユーザーのメールアドレスを挿入してください",
      }, null, '  ');
    }
    else {
      this.description = 'この配布ルールをRaffle Event Import APIで利用するために必要なリクエスト情報です。';
      this.requestTemplate = JSON.stringify({
        raffle_rule_id: this.opts.distributionRule.raffle_rule.id,
        service_uid: "ユーザーのidを挿入してください",
        conversion_at: "CVした日時をISO8601フォーマットの文字列型で挿入してください",
        email: "発行対象のユーザーのメールアドレスを挿入してください",
      }, null, '  ');
    }
    this.textareaRows = this.requestTemplate.split('\n').length + 1;

    this.onCopyRequestTemplate = () => {
      app.utils.copyToClipBoard(this.requestTemplate);
      spat.toast.message('コピーしました');
    };
});